module.exports = __webpack_public_path__ + "static/media/total-team-logo-small.bf8a4d69.png";